import React from 'react';

import ReviewRow from './ReviewRow';

const ReviewList = ({ reviews, handleReviewAction }) => (
  <>
    {reviews?.length &&
      reviews.map((review) => (
        <ReviewRow employee={review.employee} review={review.review} handleReviewAction={handleReviewAction} />
      ))}
  </>
);

export default ReviewList;
